import { render, staticRenderFns } from "./SalesForceTab.vue?vue&type=template&id=4d1a8caa&scoped=true&"
import script from "./SalesForceTab.vue?vue&type=script&lang=js&"
export * from "./SalesForceTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesForceTab.vue?vue&type=style&index=0&id=4d1a8caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a8caa",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QSelect})
